import i18n from "i18next";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { ReservableCustomerOrderLinesDataGrid } from "src/components/views/erp/sales/delivery/picking/ReservableCustomerOrderLinesDataGrid.tsx";
import { CustomerOrderLineUnreservingDataGrid } from "src/components/views/erp/sales/delivery/picking/CustomerOrderLineUnreservingDataGrid.tsx";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";

export interface CustomerOrderLineReservationViewProps {
	customerOrderId: number;
}

export const CustomerOrderLineReservationView = ({
	customerOrderId,
}: CustomerOrderLineReservationViewProps) => {
	const reservableLinesRefreshRef = useRefreshRef();
	const reservedLinesRefreshRef = useRefreshRef();

	return (
		<AavoMosaic
			viewId={"A3D8F1E5B2C94A76"}
			layout={{
				type: "tabs",
				items: [
					{
						type: "panel",
						title: i18n.t("reservable_lines"),
						content: (
							<ReservableCustomerOrderLinesDataGrid
								customerOrderId={customerOrderId}
								refreshRef={reservableLinesRefreshRef}
								onReservationCompleted={() => reservedLinesRefreshRef.refresh()}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("reserved_lines"),
						content: (
							<CustomerOrderLineUnreservingDataGrid
								customerOrderId={customerOrderId}
								refreshRef={reservedLinesRefreshRef}
								onUnreservationCompleted={() => reservableLinesRefreshRef.refresh()}
							/>
						),
					},
				],
			}}
		/>
	);
};
